import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import firebase from "firebase/app";
import 'firebase/firestore';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { red } from '@material-ui/core/colors';
import CreateIcon from '@material-ui/icons/Create';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FolderSharedIcon from '@material-ui/icons/FolderShared';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import SaveIcon from '@material-ui/icons/Save';


const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2),
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: red[500],
  },
}));

//****************************************************************carregar tipos veiculo***************** */

     
      //****************************controle atalho cadastrar***************************** */
   
  

 
  
export default function RecipeReviewCard(props) {

  const [statusrecado, setastatus] = React.useState();
  const [itemrecado, setitemrecado] = React.useState([]);
  const [recado, setarecado] = React.useState();
  const [data, setadata] = React.useState();

  React.useEffect(() => {
    
  setitemrecado(props.props);
  setarecado(props.props.recado);
  var dt = props.props.datarecado;
setadata(new Date(dt.seconds*1000).toLocaleString("pt-BR"));
setastatus(props.props.statusrecado);

     },[0]);

//*******************************salvar edit************ */

  
//********************objeto recado******************* */
  

  //**************************controle status */

 async function atualizastatus(){
   
    
  
          var strecado = firebase.firestore().collection("usuarios").doc(props.props.uid).
          collection("recados").doc(props.props.idrecado);
    
          try {
         await strecado.update({ statusrecado: "lido" });
         console.log("Document successfully updated!");
     } catch (error) {
         // The document probably doesn't exist.
         console.error("Error updating document: ", error);
     }

  }

      //************************************controle card*/
     
         
     
     
       const classes = useStyles();
       const [expanded, setExpanded] = React.useState(false);
     
       const handleExpandClick = () => {
         setExpanded(!expanded);
         if((!expanded)&&(statusrecado=="novo")){
         
            atualizastatus();
       };
    }
     
       return (
         <Card className={classes.root} >
                <CardHeader
                  avatar={
                      data
                  }

                  action={
                    <IconButton
                    className={clsx(classes.expand, {
                      [classes.expandOpen]: expanded,
                    })}
                    onClick={handleExpandClick}
                    aria-expanded={expanded}
                    aria-label="Visualizar"
                  >
                    <ExpandMoreIcon />
                  </IconButton>
                  }
                 
                  //title= {trecho}
                  //subheader= {itemmotora.map(modelo=>(modelo.matricula))}
          
                />

                
                                           
                                          
                 
                <Collapse in={expanded} timeout="auto" unmountOnExit>
                  <CardContent>
                          {recado}                                       
                     
                  </CardContent>
                  
                </Collapse>
              </Card>
       );
     }
 